import React, { forwardRef, useImperativeHandle } from 'react';

import { IStepperImperativeHandleProps } from '../../../../../common/stepper';
import { AppointmentSuccessStep as AppointmentSuccessStepView } from './appointment-success-step';
import { AppointmentSuccessStepProps } from './appointment-success-step.models';

export const AppointmentSuccessStep = forwardRef<
IStepperImperativeHandleProps, AppointmentSuccessStepProps>(({
  onGoNextSuccess,
  externalState,
}, ref): JSX.Element => {
  const onReviewFittingRequest = externalState.onReviewFittingRequest;

  useImperativeHandle(ref, () => ({
    goNext() {
      onReviewFittingRequest?.();
      onGoNextSuccess();
    },
    goBack() { },
  }));

  return (
    <AppointmentSuccessStepView />
  );
});
